const navigation = document.getElementById('navigation');
const navigationToggler = navigation?.querySelector('.navbar-toggler');
const dropdown = document.getElementById('navigation-dropdown');

/** Ścieżka we własnym serwisie, ale nie plik do pobrania (np. regulamin w PDF). */
const isInternalPage = (href) => href.startsWith('/') && !/\.[a-z0-9]+$/i.test(href);

dropdown?.querySelectorAll('.nav-item').forEach((item) => {
	if (!item.classList.contains('dropdown')) {
		item.addEventListener('click', () => {
			toggleDropdown();
		});
	}

	const href = item.querySelector('a').getAttribute('href');

	// Panel zamykamy przy wejściu w pozycję menu prowadzącą w obrębie serwisu — tak dla
	// zakotwiczeń na stronie głównej, jak i dla osobnych stron (np. /ranking), gdzie panel
	// przesłaniałby treść po przejściu. Stan jest zapamiętywany, więc nowa strona wstaje
	// już ze zwiniętym panelem.
	if (href.startsWith('#') || href.startsWith('/#') || isInternalPage(href)) {
		item.querySelector('a').addEventListener('click', () => {
			changePaneCollapsed(true);
		})
	}
});

const toggleDropdown = () => {
	if (navigationToggler?.getAttribute('aria-expanded') == 'true') {
		navigationToggler?.click();
	}
};

/*
 *	Zwijanie bocznego panelu nawigacji (lg i wyżej).
 *	Stan trzymamy na <body>, bo zależy od niego też przygaszenie strony.
 */
const PANE_COLLAPSED_CLASS = 'has-navigation-collapsed';
const PANE_STORAGE_KEY = 'navigation-collapsed';

const paneToggle = document.getElementById('navigation-pane-toggle');
const paneBackdrop = document.getElementById('navigation-pane-backdrop');

const setPaneCollapsed = (collapsed) => {
	document.body.classList.toggle(PANE_COLLAPSED_CLASS, collapsed);
	paneToggle?.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
};

const isPaneCollapsed = () => document.body.classList.contains(PANE_COLLAPSED_CLASS);

// Panel domyślnie jest zwinięty — klasę niesie już `<body>` z szablonu, więc strona
// nie mignie otwartym panelem. Rozwijamy go tylko wtedy, gdy poprzednia wizyta
// wyraźnie tak go zostawiła. Animacje włączamy dopiero w kolejnej klatce
// (klasa `navigation-ready`)
try {
	setPaneCollapsed(localStorage.getItem(PANE_STORAGE_KEY) !== '0');
} catch (e) {
	// brak dostępu do localStorage (np. tryb prywatny) — zostaje stan domyślny
}

requestAnimationFrame(() => {
	document.body.classList.add('navigation-ready');
});

const changePaneCollapsed = (collapsed) => {
	setPaneCollapsed(collapsed);

	try {
		localStorage.setItem(PANE_STORAGE_KEY, collapsed ? '1' : '0');
	} catch (e) {
		// brak dostępu do localStorage — stan nie zostanie zapamiętany
	}
};

paneToggle?.addEventListener('click', () => {
	changePaneCollapsed(!isPaneCollapsed());
});

// Klik w przygaszone tło zamyka panel
paneBackdrop?.addEventListener('click', () => {
	changePaneCollapsed(true);
});
